const If = p => p.is ? p.children : false
export default If
